import React from 'react'

export default function Pt() {
  return (
    <div class="ptsivu">
      <h2> Personal Trainer palvelut</h2>
      <br />
      <div class="pt-content">
        <p id="pt">Voit valita joko valmennuksen kertoina tai kuukausina!</p>
        <table id ="pttable">
          <tr>
            <th>Kertavalmennus</th>
            <th>Kuukausivalmennus</th>
          </tr>
          <tr>
            <td>Kertavalmennuskerrat sopivat oivasti
                henkilöille, jotka kaipaavat tuloksia
                harjoitteluun.</td>
            <td>Sopii erinomaisesti tukea kaipaavalle liikkujalle tai 
              aloittelevalle kuntoilijalle, myös ilman aikaisempaa liikuntataustaa </td>
          </tr>
          <tr>
            <td>Ei sitovaa kuukausimäärää</td>
            <td>Ei sitovaa kuukausimäärää</td>
          </tr>
          <tr>
            <td>Käytä valmennuskerrat siitä aikataulussa kuin
                itse haluat.</td>
            <td>Maksat vain niistä kuukausista, joille tilaat
                valmennukset</td>
          </tr>
          <tr>
            <td>Ottaa huomioon erinomaisesti erilaiset elämän
                tilanteet.</td>
                <td>Ottaa huomioon erinomaisesti erilaiset elämän
                    tilanteet.</td>
          </tr>
          <tr>
            <td>
              <ul id="ptlista">
                <li>Alkuhaastattelu</li>
                <li>Alkukartoitus</li>
                <li>Tavoitteiden asettaminen</li>
                <li>Seuranta ja tuki (esim. Step2Fitin avulla)</li>
                <li>Henkilökohtainen, tavoitteellinen
                    harjoitteluohjelma</li>
                <li>Harjoitusohjelman tavoitteellinen päivitys</li>
                <li>Lisämaksullisina palveluina ravintosuunnitelma ja sopimushintaiset hieronnat </li>
              </ul>
            </td>
            <td>
              <ul id="ptlista">
                <li>Alkuhaastattelu</li>
                <li>Alkukartoitus</li>
                <li>Tavoitteiden asettaminen</li>
                <li>Ravintoneuvonta</li>
                <li>Ruokapäiväkirja</li>
                <li>Seuranta ja tuki (esim. Step2Fitin avulla)</li>
                <li>Halutessa lajikohtainen, tavoitteellinen
                    harjoitteluohjelma</li>
                <li>Harjoitusohjelman tavoitteellinen päivitys</li>
                <li>1-2 tapaamista valmentajan kanssa kuukaudessa</li>
              </ul>
            </td>
          </tr>
        </table>

      </div>
    </div>
  )
}